import React from "react"
import { Link } from "gatsby"
import get from "lodash/get"
import { css } from "@emotion/core"
import tw from "twin.macro"
import { MdKeyboardArrowRight } from "react-icons/md"
import { FaFacebook, FaLinkedin, FaTwitter } from "react-icons/fa"

import Layout from "../components/Layout"
import Curve from "../components/Curve"
import { linkResolver } from "../../prismic.config"
import useLabels from "../components/useLabels"
import ImageResolver from "../components/ImageResolver"

export default function BodyBase({
  data,
  seo,
  pageContext,
  type,
  slugUID,
  title,
}) {
  const {
    allTags,
    usedTags,
    recentPosts,
    allCategories,
    config,

    postsPerCategory,
  } = data
  const labels = useLabels(pageContext.lang)
  const posts = get(data, "posts.nodes")
  const blog = get(data, "blog")
  return (
    <Layout pageContext={pageContext} seo={seo}>
      <div className="phone:pt-32 pt-40 pb-20 bg-light  ">
        <div
          className="prose text-center mx-auto"
          css={css`
            h1 {
              ${tw`text-2xl`}
            }
          `}
        >
          <h1>{get(blog, "data.title.text") || title}</h1>
        </div>
      </div>
      <Curve className="text-white" />
      {(pageContext.category || pageContext.tag) && (
        <div className="container relative z-10 -mt-5 text-center">
          <div className="inline-flex flex-wrap items-center justify-center px-6 py-2 text-sm font-semibold bg-white rounded text-light-text phone:px-3 filter-shadow">
            <Link
              className="text-primary"
              to={linkResolver({
                type: "page",
                lang: pageContext.lang,
                uid: "blog",
              })}
            >
              Blog
            </Link>{" "}
            <MdKeyboardArrowRight />
            <span className="text-primary"> {title.split("-")[1]}</span>
          </div>
        </div>
      )}
      <div className="container py-20">
        <div className="row phone:space-y-6 relative items-start mb-10">
          <div className="col w-full lg:w-2/3 space-y-8">
            {posts &&
              posts.map((post, index) => {
                const image = get(post, "data.featured_image")
                return (
                  <div
                    key={index}
                    className="border rounded-md overflow-hidden"
                  >
                    <div className="row md:items-center">
                      <div
                        className="col w-full md:w-1/2"
                        css={css`
                          ${index % 2 ? tw`md:order-last pl-0!` : tw`pr-0!`}
                        `}
                      >
                        <Link
                          to={linkResolver({
                            type: "post",
                            lang: pageContext.lang,
                            uid: post.uid,
                          })}
                        >
                          {image && (
                            <ImageResolver
                              image={image}
                              style={{ minHeight: 300 }}
                            />
                          )}
                        </Link>
                      </div>
                      <div
                        className="col w-full md:w-1/2 py-8"
                        css={css`
                          ${tw`px-8!`}
                        `}
                      >
                        <h3>{post.data.title.text}</h3>
                        <div className="prose tablet:prose-tablet">
                          <p>{get(post, "data.text.excerpt")}</p>
                          <p tw="text-sm! -mt-3! opacity-80! ">
                            {get(post, "data.date")}
                          </p>
                        </div>
                        <Link
                          className="text-primary inline-flex items-center text-sm mt-4"
                          to={linkResolver({
                            type: "post",
                            lang: pageContext.lang,
                            uid: post.uid,
                          })}
                        >
                          {labels.read_more} <MdKeyboardArrowRight />
                        </Link>
                      </div>
                    </div>
                  </div>
                )
              })}
            <Pagination
              pageContext={pageContext}
              labels={labels}
              type={type}
              slugUID={slugUID}
            />
          </div>
          <div className="col w-full lg:w-1/3 tablet:mt-8  sticky  top-4">
            <div className="border rounded-md overflow-hidden p-4">
              <h3 className="font-semibold text-lg mb-4">
                {labels.categories}
              </h3>
              <div className="mb-6">
                {allCategories.nodes &&
                  allCategories.nodes
                    .filter((category) => {
                      const count = postsPerCategory.group.find(
                        (g) => g.fieldValue === category.uid
                      )
                      return count && count.totalCount
                    })
                    .map((category) => {
                      const count = postsPerCategory.group.find(
                        (g) => g.fieldValue === category.uid
                      )
                      return (
                        <Link
                          css={css`
                            ${tw`flex justify-between text-sm text-light-text mb-3`}
                          `}
                          to={linkResolver({
                            type: "category",
                            lang: pageContext.lang,
                            uid: category.uid,
                            route_prefix: labels.category_route,
                          })}
                          key={category.uid}
                        >
                          {category.data.category}{" "}
                          <span>{count ? count.totalCount : 0}</span>
                        </Link>
                      )
                    })}
              </div>
              <h3 className="font-semibold text-lg mb-4">
                {labels.recent_post}
              </h3>
              <div className="mb-6">
                {recentPosts.nodes &&
                  recentPosts.nodes.map((post) => {
                    return (
                      <Link
                        to={linkResolver({
                          type: "post",
                          lang: pageContext.lang,
                          uid: post.uid,
                        })}
                        key={post.uid}
                        css={css`
                          ${tw`grid gap-2 mb-4`}
                          grid-template-columns: 75px auto;
                        `}
                      >
                        <div>
                          {post.data.featured_image && (
                            <ImageResolver
                              className="h-10 rounded-sm"
                              objectFit="cover"
                              image={post.data.featured_image}
                            />
                          )}
                        </div>
                        <div>
                          <h4 className="text-xs font-semibold">
                            {post.data.title.text}
                          </h4>
                          <p className="text-xs text-light-text">
                            {post.data.date}
                          </p>
                        </div>
                      </Link>
                    )
                  })}
              </div>
              <h3 className="font-semibold text-lg mb-4">{labels.tag_cloud}</h3>
              <div className="flex flex-wrap mb-6">
                {allTags.nodes &&
                  allTags.nodes
                    .filter((tag) => {
                      return usedTags.group.find(
                        (g) => g.fieldValue === tag.uid
                      )
                    })
                    .map((tag) => {
                      return (
                        <Link
                          css={css`
                            ${tw`rounded bg-light text-light-text font-semibold px-2 py-1 text-xs mr-3 my-1`}
                          `}
                          to={linkResolver({
                            type: "tag",
                            lang: pageContext.lang,
                            uid: tag.uid,
                            route_prefix: labels.tag_route,
                          })}
                          key={tag.uid}
                        >
                          {tag.data.tag}
                        </Link>
                      )
                    })}
              </div>
              <h3 className="font-semibold text-lg mb-4">{labels.follow_us}</h3>
              <div
                className="text-2xl flex space-x-5 text-light-text mb-4"
                css={css`
                  a {
                    ${tw`opacity-75 hover:opacity-100`}
                  }
                `}
              >
                <a href={get(config, "data.linkedin_link")}>
                  <FaLinkedin />
                </a>
                <a href={get(config, "data.facebook_link")}>
                  <FaFacebook />
                </a>
                <a href={get(config, "data.twitter_link")}>
                  <FaTwitter />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

function Pagination({ pageContext, labels, type, slugUID }) {
  const { totalPages, currentIndex } = pageContext
  let slugBase = "blog"
  switch (type) {
    case "category":
      slugBase = labels.category_route + "/" + slugUID
      break

    case "tag":
      slugBase = labels.tag_route + "/" + slugUID
      break

    default:
      break
  }
  let paginationNumbers = Array.from({ length: totalPages })
    .map((_, i) => {
      if (totalPages < 5) {
        return { index: i, number: i + 1 }
      }
      if (currentIndex === i) {
        return { index: i, number: i + 1 }
      }
      if (currentIndex - 3 === i) {
        return { index: i, number: "..." }
      }
      if (currentIndex - 2 === i) {
        return { index: i, number: i + 1 }
      }
      if (currentIndex - 1 === i) {
        return { index: i, number: i + 1 }
      }
      if (currentIndex + 1 === i) {
        return { index: i, number: i + 1 }
      }
      if (currentIndex + 2 === i) {
        return { index: i, number: i + 1 }
      }
      if (totalPages - 1 === i) {
        return { index: i, number: i + 1 }
      }
      if (currentIndex + 3 === i && currentIndex + 4 !== totalPages) {
        return { index: i, number: "..." }
      }
      return null
    })
    .filter(Boolean)

  return (
    totalPages > 1 && (
      <div className="flex items-center justify-center">
        <div
          className="flex px-1 items-center border border-light-2 rounded-full divide-x  divide-light-2"
          css={css`
            > * {
              ${tw`phone:px-2.5 px-4 py-2`}
            }
          `}
        >
          <Link
            to={linkResolver({
              lang: pageContext.lang,
              type: "page",
              uid: currentIndex < 2 ? slugBase : `${slugBase}/${currentIndex}`,
            })}
          >
            {labels.prev}
          </Link>
          {paginationNumbers.map((item, i) => {
            return (
              <Link
                to={linkResolver({
                  lang: pageContext.lang,
                  type: "page",
                  uid:
                    item.index == 0
                      ? slugBase
                      : `${slugBase}/${item.index + 1}`,
                })}
                className="cursor-pointer"
                css={css`
                  ${item.index === currentIndex && tw`bg-primary text-white`}
                `}
              >
                {item.number}
              </Link>
            )
          })}
          <Link
            to={linkResolver({
              lang: pageContext.lang,
              type: "page",
              uid:
                currentIndex + 1 === totalPages
                  ? `${slugBase}/${currentIndex + 1}`
                  : `${slugBase}/${currentIndex + 2}`,
            })}
          >
            {labels.next}
          </Link>
        </div>
      </div>
    )
  )
}
